import React from 'react';
import { QuestionFolder } from '@/types';

interface FolderBreadcrumbProps {
  path: QuestionFolder[];
  onNavigate: (folderId: string | null) => void;
}

export const FolderBreadcrumb: React.FC<FolderBreadcrumbProps> = ({ path, onNavigate }) => {
  return (
    <div className="flex items-center gap-2 text-sm text-gray-600 mb-4">
      {/* Root folder */}
      <button
        onClick={() => onNavigate(null)}
        className="hover:text-blue-600 hover:underline transition-colors"
      >
        📂 All Games
      </button>

      {/* Breadcrumb trail */}
      {path.map((folder, index) => (
        <React.Fragment key={folder.id}>
          <span className="text-gray-400">/</span>
          <button
            onClick={() => onNavigate(folder.id)}
            className={`hover:text-blue-600 hover:underline transition-colors ${
              index === path.length - 1 ? 'font-semibold text-gray-900' : ''
            }`}
          >
            {folder.icon && <span className="mr-1">{folder.icon}</span>}
            {folder.name}
          </button>
        </React.Fragment>
      ))}
    </div>
  );
};
